<template>
  <v-app>
    <navigation :currentNavigation="path"></navigation>
    <nameInput></nameInput>
      <v-main>
        <v-container fluid>
          <v-row class="d-flex justify-center align-center">
            <v-col md="auto" align="center" justify="center">
                <years id="yearSelector" v-model="selectedYear"></years>
            </v-col>
            <v-col md="auto" align="center">
              <settings 
                @bizDevSettings="bizDevSettingsChange"
                :settingsReset="productExport.settingsReset"
                :doors="productExport.doors"
                :category="selectedCategory"
                :year="selectedYear"></settings>
            </v-col>
            <v-col md="auto">
              <forecastCheck
                v-model="checkForecastInfo"
                :year="selectedYear"
                :category="selectedCategory"
                :forecastQtys="productExport.forecastQtys"
                :products="productExport.products"
              />
            </v-col>
            <v-col md="auto">
              <forecastCategories v-model="selectedCategory"></forecastCategories>
            </v-col>
            <v-col align="end">
                <goalProgress 
                  class="pa-2"
                  :part="productExport.goal.part"
                  :whole="productExport.goal.whole"/>
            </v-col>
          </v-row>
        <forecastTable 
          v-model="productExport"
          :refresh="refresh"
          :year="selectedYear" 
          :preorderDetails="settings.preorderDetails"
          :category="selectedCategory" 
          :otherSettings="settings.otherSettings"
          :checkForecastInfo="checkForecastInfo"
        ></forecastTable>
        </v-container>
      </v-main>
  </v-app>
</template>

<style src="@/stylesheet.css" scoped></style>

<script>
import forecastTable from '@/components/Home/forecastTable.vue'
import forecastCategories from '@/components/Home/forecastCategories.vue'
import years from '@/components/Home/years.vue'
import navigation from '@/components/General/navigation.vue'
import ForecastCheck from '@/components/Home/forecastCheck.vue'
import goalProgress from '@/components/Home/goalProgress.vue'
import settings from '@/components/Home/settings.vue'
import nameInput from '@/components/General/nameInput.vue'

export default {
  name: 'Home',
  components: {
    forecastCategories,
    forecastTable,
    years,
    navigation,
    ForecastCheck,
    goalProgress,
    settings,
    nameInput,
  },
  watch: {
    'productExport.currentDoors': function() {
      this.doors.current = this.productExport.currentDoors
    },
  },
  data: () => ({
    dialog: false,
    selectedYear: 0,
    selectedCategory: {
      Forecast_Name: '',
      Active: 0,
      Preorder: 0,
    }, 
    path:'/',
    refresh: 0,
    productExport: {
      doors: {},
      forecastQtys: [],
      products: [],
      goal: {
        part: 0,
        whole: 0,
      },
      settingsReset: 0,
    },
    settings: {
      doors: {
        firstHalfPrediction: 0,
        secondHalfPrediction: 0
      }
    },
    checkForecastInfo: {
      month: 0,
      product: {},
      refresh: 0,
    }
  }),
  methods: {
    bizDevSettingsChange() {
      this.refresh += 1
    }
  },
  computed: {
  }
};
</script>
